import ListItem from "../generic/list-item";
import templates from "../../utils/templates";

const DEFAULTS = {
  template: templates.find("report", "role_selector"),
};

class View extends ListItem {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }
}

export { View as default };
